import getUrl from './getUrl.js';

export default function shippingProfile(idShop) {
    return fetch(`${getUrl()}/v2/shipping/profile/${idShop}`, {
      method: 'GET',
      headers: {
        'Content-type':'application/json'
      },
      credentials: 'include',
    })
    .then((res) => res.json())
}